import React from "react";
import { Link } from "react-router-dom";
import { getLocalUser, deleteLocalUser } from "../../database/localStorage";

function Avatar({ roles, openModal, colourBlindMode, onColourBlindMode, offColourBlindMode }) {
	return (
		<div className="dropdown-center">
			<button
				className="btn btn-secondary avatar-btn"
				type="button"
				data-bs-toggle="dropdown"
				aria-expanded="false"
			>
				<p className="username">
					USER@ONE
					<br />
					{roles === "Admin" && (
						<span className="usertag">ADMIN</span>
					)}
					{roles === "Member" && (
						<span className="usertag">MEMBER</span>
					)}
				</p>
				<p className="avatar-img">U</p>
			</button>
			<ul className="dropdown-menu avatar-dropdown-menu">
				<li>
					<div
						className="dropdown-item bg-transparent"
						onClick={() => openModal()}
					>
						<i className="fa-solid fa-key fa-xs avatar-dropdown-item-icon "></i>
						<span className="avatar-dropdown-item-text ">
							{" "}
							Password
						</span>
					</div>
				</li>
				<li>
					<hr className="dropdown-divider" />
				</li>
				<li>
					{colourBlindMode === false && (
					<div
						className="dropdown-item bg-transparent"
						onClick={() => onColourBlindMode()}
					>
						<i className="fa-solid fa-eye fa-xs avatar-dropdown-item-icon "></i>
						
							<span className="avatar-dropdown-item-text">
								{" "}
								Colour Blind Mode On
							</span>
						
					</div>
					)}

					{colourBlindMode === true && (
					<div
						className="dropdown-item bg-transparent"
						onClick={() => offColourBlindMode()}
					>
						<i className="fa-solid fa-eye fa-xs avatar-dropdown-item-icon "></i>
						
							<span className="avatar-dropdown-item-text">
								{" "}
								Colour Blind Mode Off
							</span>
						
					</div>
					)}
					
				</li>
				<li>
					<hr className="dropdown-divider" />
				</li>
				<li>
					<Link
						to="/"
						className="dropdown-item"
						href="#"
						onClick={() => deleteLocalUser()}
					>
						<i className="fa-solid fa-arrow-right-from-bracket fa-xs avatar-dropdown-item-icon"></i>
						<span className="avatar-dropdown-item-text">
							{" "}
							Logout
						</span>
					</Link>
				</li>
			</ul>
		</div>
	);
}

export default Avatar;
